import React from "react";

export function BoldCrossIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="interface-add-2--remove-bold-cross-buttons-button-add-plus--Streamline-Core">
        <path
          id="Vector"
          d="M27 13C27 12.4696 26.7893 11.9609 26.4142 11.5858C26.0391 11.2107 25.5304 11 25 11H17V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H13C12.4696 1 11.9609 1.21071 11.5858 1.58579C11.2107 1.96086 11 2.46957 11 3V11H3C2.46957 11 1.96086 11.2107 1.58579 11.5858C1.21071 11.9609 1 12.4696 1 13V15C1 15.5304 1.21071 16.0391 1.58579 16.4142C1.96086 16.7893 2.46957 17 3 17H11V25C11 25.5304 11.2107 26.0391 11.5858 26.4142C11.9609 26.7893 12.4696 27 13 27H15C15.5304 27 16.0391 26.7893 16.4142 26.4142C16.7893 26.0391 17 25.5304 17 25V17H25C25.5304 17 26.0391 16.7893 26.4142 16.4142C26.7893 16.0391 27 15.5304 27 15V13Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect={vectorEffect}
        />
      </g>
    </svg>
  );
}
